import { render, staticRenderFns } from "./CounterDetail.vue?vue&type=template&id=0431fd13&scoped=true&"
import script from "./CounterDetail.vue?vue&type=script&lang=js&"
export * from "./CounterDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0431fd13",
  null
  
)

export default component.exports